// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"fd9a36b4107bb931c03d","655":"05c44c537b0747d9f914"}[chunkId] + ".js";
};